import { css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorFunctional } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'

export const returnDetails = css`
  .rma-return-details {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing06};
    padding-bottom: ${csSpacing.spacing06};
  }

  .rma-return-details__error {
    color: ${csColorFunctional.error};
    margin-top: ${csSpacing.spacing02};
  }

  .rma-return-details__quantity-row {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
    align-items: stretch;

    @media (min-width: ${SCREENS.extraSmall}) {
      flex-direction: row;
      flex-wrap: wrap;
      align-items: flex-start;
    }
  }

  .rma-return-details__field--quantity {
    flex: 0 0 auto;
  }

  .rma-return-details__field--reason {
    flex: 1 1 auto;

    @media (min-width: ${SCREENS.extraSmall}) {
      flex: 1 1 12rem;
    }
  }

  .rma-return-details__quantity {
    display: flex;
    align-items: center;
    gap: ${csSpacing.spacing04};
  }

  .rma-return-details__quantity-input {
    --cse-text-input-width: 4rem;
  }

  .rma-return-details__actions {
    display: flex;
    flex-wrap: wrap;
    gap: ${csSpacing.spacing06};
    align-items: flex-end;
  }

  .rma-return-details__return {
    margin-left: auto;
  }

  .rma-return-details__memo-row {
    display: flex;
    flex-wrap: wrap;
    gap: ${csSpacing.spacing06};
  }

  .rma-return-details__memo-row > * {
    flex: 1 1 12rem;
  }

  .rma-return-details__field {
    display: flex;
    flex-direction: column;
  }

  .rma-return-details__upload {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
    max-width: 100%;
  }

  .rma-return-details__files {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing02};
  }

  @media (min-width: ${SCREENS.small}) {
    .rma-return-details__upload {
      max-width: 55%;
    }
  }
`
